import { CounterpartyLimitViewModel, TradingCounterpartyLegalHierarchyOwnership } from './CounterpartyLimits.component.model'
import { ExchangeRateEF, TradingEntityLegalHierarchyOwnership } from '../../../../limit-management/TradingLimits.model';
import { ConsoleLoggerService } from '../../../../common/LoggerService/console-logger.service';
import { UtilityService } from '../../../../common/utility.service';
import { CounterpartyLimitsCommonManager } from '../CounterpartyLimits/CounterpartyLimits.common';

//@Injectable()
export class OurEntityLimitsManager {
  __iOurEntityUnderHierarchy: number[] = [];
  __oDataSource: CounterpartyLimitViewModel[] = [];
  __trvInstance: any = {};
  __sMessage: string = "";
  __oLogger: ConsoleLoggerService;
  constructor(oLogger: ConsoleLoggerService) {
    this.__oLogger = oLogger;
  }
  //currency conversion to be done wrt overall limit currency
  currencyConversion(limitValue: any, fromCurrency: number, toCurrency: number, oExchangeRateEFs: ExchangeRateEF[]): number {
    try {
      let nReturn = limitValue;
      let nExchangeRate = 1;
      if (oExchangeRateEFs && oExchangeRateEFs.length > 0 && oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency)) {
        nExchangeRate = oExchangeRateEFs.find(x => x.lFromCurrencyId == fromCurrency && x.lToCurrencyId == toCurrency).ConversionRate;
      }
      nReturn = Math.floor(limitValue * nExchangeRate);
      return nReturn;
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while currencyConversion function.');
    }
  }
  ///drill down the hierarchy
  normalize(parent: any, nIdentifyCpty: number, bIsImmidiateParent: boolean) {
    try {
      if (parent && parent.TradingEntityLegalHierarchyOwnershippings) {
        let IsItemFound: boolean = false;
        for (var i = 0, l = parent.TradingEntityLegalHierarchyOwnershippings.length; i < l; ++i) {
          child = parent.TradingEntityLegalHierarchyOwnershippings[i];
          if ((child.lChildTradingEntityId == nIdentifyCpty)) {

            if (bIsImmidiateParent) {
              if (child.TradingEntityLegalHierarchyOwnershippings && child.TradingEntityLegalHierarchyOwnershippings.length > 0) {
                child.TradingEntityLegalHierarchyOwnershippings.forEach(x => this.__iOurEntityUnderHierarchy.push(x.lChildTradingEntityId));
              }
              break;
            };

            this.extractOurEntityFromHierarchy(child);
            if (this.__iOurEntityUnderHierarchy.filter(c => c == child.lChildTradingEntityId).length == 0) {
              this.__iOurEntityUnderHierarchy.push(child.lChildTradingEntityId);
            }

          }
          var child = parent.TradingEntityLegalHierarchyOwnershippings[i];
          this.normalize(child, nIdentifyCpty, false);
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while normalize function.');
    }
  }
  //gets all counterparties under a node
  extractOurEntityFromHierarchy(parent: any) {
    try {
      if (parent && parent.TradingEntityLegalHierarchyOwnershippings.length > 0) {
        for (var i = 0, l = parent.TradingEntityLegalHierarchyOwnershippings.length; i < l; ++i) {
          var child = parent.TradingEntityLegalHierarchyOwnershippings[i];
          if (this.__iOurEntityUnderHierarchy.filter(x => x == child.lChildTradingEntityId).length == 0) {
            this.__iOurEntityUnderHierarchy.push(child.lChildTradingEntityId);
          }
          this.extractOurEntityFromHierarchy(child);
        }
      }
      else if (parent) {
        if (this.__iOurEntityUnderHierarchy.filter(x => x == parent.lChildTradingEntityId).length == 0) {
          this.__iOurEntityUnderHierarchy.push(parent.lChildTradingEntityId);
        }
      }
    } catch (oError) {
      this.__oLogger.Write(oError, 'Error', 'Error occurred while extractOurEntityFromHierarchy function.');
    }
  }
  //validations on limits
  validateLimit(bValidated: boolean, oDatasource: CounterpartyLimitViewModel[], oSystemSettings: any, oExchangeRateEFs: ExchangeRateEF[], otrCounterpartyLimits: any, oTradingEntityLegalHierarchyOwnerships: TradingEntityLegalHierarchyOwnership[], __oUtilityService: UtilityService, oTradingCounterpartyLegalHierarchyOwnerships: TradingCounterpartyLegalHierarchyOwnership[]): any {
    try {
      let sMessage: string = "";
      this.__oDataSource = oDatasource;
      this.__trvInstance = otrCounterpartyLimits;
      let oCounterpartyLimitsCommonManager: CounterpartyLimitsCommonManager = new CounterpartyLimitsCommonManager(oDatasource, otrCounterpartyLimits, this.__oLogger);
      if (oSystemSettings[0].IsEntityLimitValidated === 1 && bValidated) {
        oDatasource.filter(z => z.IsOverall === 1 && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
          let oParentLimit = oDatasource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
          if (bValidated && !oParentLimit) {
            bValidated = false;
            sMessage = 'The Trading Category limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
          }
        });

        //commodity validations wrt immidiate parent
        if (bValidated) {
          oDatasource.filter(z => z.IsOverall === 1 && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
            this.__iOurEntityUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
            this.normalize(oTradingEntityLegalHierarchyOwnerships[0], x.lParentTradingEntityId, true);

            let oTempDataSource = oDatasource.filter(z => this.__iOurEntityUnderHierarchy.indexOf(z.lOurEntityId) !== -1 && z.lOurEntityId != oParentLimit.lOurEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oParentLimit.lTradingCategoryId);//FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
          oDatasource.filter(z => z.IsOverall === 1 && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId == z.lOurEntityId).forEach(x => {
            this.__iOurEntityUnderHierarchy = [];
            let oParentLimit = x;
            var oItem: any = oTradingEntityLegalHierarchyOwnerships[0];
            oItem.TradingEntityLegalHierarchyOwnershippings.forEach(c => this.__iOurEntityUnderHierarchy.push(c.lChildTradingEntityId));
            let oTempDataSource = oDatasource.filter(z => this.__iOurEntityUnderHierarchy.indexOf(z.lOurEntityId) !== -1 && z.lOurEntityId != oParentLimit.lOurEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oParentLimit.lTradingCategoryId);//FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
        }
        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
            this.__iOurEntityUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
            if (bValidated && !oParentLimit) {
              bValidated = false;
              sMessage = 'The Overall limit for Parent does not exist for Counterparty: ' + x.TradingCounterpartyName + ", Our Entity: " + x.TradingEntityName + ", Limit Type: " + x.LimitTypeName + " and Trading Category: " + x.TradingCategoryName + ". Please add.";
            }
          });
        }

        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
            this.__iOurEntityUnderHierarchy = [];
            let oParentLimit = oDatasource.find(z => z.lOurEntityId == x.lParentTradingEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
            this.normalize(oTradingEntityLegalHierarchyOwnerships[0], x.lParentTradingEntityId, true);
            let oTempDataSource = oDatasource.filter(z => this.__iOurEntityUnderHierarchy.indexOf(z.lOurEntityId) !== -1 && z.lOurEntityId != oParentLimit.lOurEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });

          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId == z.lOurEntityId).forEach(x => {
            this.__iOurEntityUnderHierarchy = [];
            let oParentLimit = x;
            var oItem: any = oTradingEntityLegalHierarchyOwnerships[0];
            oItem.TradingEntityLegalHierarchyOwnershippings.forEach(c => this.__iOurEntityUnderHierarchy.push(c.lChildTradingEntityId));
            let oTempDataSource = oDatasource.filter(z => this.__iOurEntityUnderHierarchy.indexOf(z.lOurEntityId) !== -1 && z.lOurEntityId != oParentLimit.lOurEntityId && z.TradingCounterpartyName == x.TradingCounterpartyName && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
            ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
          });
        }
        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";
      }

      if (oSystemSettings[0].IsEntityLimitValidated === 24 && oSystemSettings[0].IsCounterPartyLimitValidated === 14 && bValidated) {

        let oTreeDatasource = oCounterpartyLimitsCommonManager.buildOETree(JSON.parse(JSON.stringify(oDatasource)), oTradingEntityLegalHierarchyOwnerships, oTradingCounterpartyLegalHierarchyOwnerships);//oCounterpartyLimitsCommonManager.buildtree(JSON.parse(JSON.stringify(oDatasource));

        if (bValidated) {
          oTreeDatasource.filter(z => z.TradingCategoryName === "Overall").forEach(x => {
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lParentCounterpartyLimitId);
              if (oParentLimit) {
                let oTempDataSource = oTreeDatasource.filter(z => z.lParentCounterpartyLimitId == oParentLimit.lCounterpartyLimitId);
                ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
              }
            }
          });
        }

        if (bValidated) {
          oTreeDatasource.filter(z => z.IsOverall === 1).forEach(x => {
            if (x.lTradingCounterpartyId === oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && x.lOurEntityId === oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId) {

            }
            else {
              let oParentLimit = oTreeDatasource.find(z => z.lCounterpartyLimitId == x.lParentCounterpartyLimitId);
              if (oParentLimit) {
                let oTempDataSource = oTreeDatasource.filter(z => z.lParentCounterpartyLimitId == oParentLimit.lCounterpartyLimitId);
                ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
              }
            }
          });
        }

        this.__oDataSource.forEach(x => {
          x.CounterpartyLimitWarnings = oTreeDatasource.filter(z => z.lCounterpartyLimitId == x.lCounterpartyLimitId)[0].CounterpartyLimitWarnings;
        });

        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";

      }

      if (oSystemSettings[0].IsEntityLimitValidated === 2 && oSystemSettings[0].IsCounterPartyLimitValidated !== 1 && bValidated) {
        //commodity validations
        if (bValidated) {
          oDatasource.filter(z => z.IsOverall === 1 && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
            let oUltimateParentLimit = oDatasource.find(z => z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.TradingCategoryName == x.TradingCategoryName && z.SubLimitTypeName === x.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1);//FB43985-Pawan Prajapati
            if (oUltimateParentLimit) {
              let oTempDataSource = oDatasource.filter(z => z.lCounterpartyLimitId != oUltimateParentLimit.lCounterpartyLimitId && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.IsOverall === 1 && z.lTradingCategoryId == oUltimateParentLimit.lTradingCategoryId);//&& z.TradingCounterpartyName == x.TradingCounterpartyName//FB43985-Pawan Prajapati
              ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oUltimateParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
            }
          });
        }

        if (bValidated) {
          oDatasource.filter(z => z.TradingCategoryName === "Overall" && oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId !== z.lOurEntityId).forEach(x => {
            let oUltimateParentLimit = oDatasource.find(z => z.lOurEntityId == oTradingEntityLegalHierarchyOwnerships[0].lChildTradingEntityId && z.lTradingCounterpartyId == oTradingCounterpartyLegalHierarchyOwnerships[0].lChildTradingCounterpartyId && z.SubLimitTypeName === x.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//FB43985-Pawan Prajapati
            if (oUltimateParentLimit) {
              let oTempDataSource = oDatasource.filter(z => z.lCounterpartyLimitId != oUltimateParentLimit.lCounterpartyLimitId && z.SubLimitTypeName === z.SubLimitTypeName && z.LimitTypeName == x.LimitTypeName && z.TradingCategoryName === "Overall");//&& z.TradingCounterpartyName == x.TradingCounterpartyName//FB43985-Pawan Prajapati
              ({ bValidated, sMessage } = oCounterpartyLimitsCommonManager.validateImmidiateParent(oTempDataSource, oUltimateParentLimit, bValidated, sMessage, oSystemSettings, oExchangeRateEFs));
            }
          });
        }
        this.__oDataSource.filter(x => x.CounterpartyLimitWarnings && x.CounterpartyLimitWarnings.length > 0).length > 0 ? bValidated = false : "";
      }
      this.__sMessage = sMessage;
    }
    catch (e) {
      this.__oLogger.Write(e, 'Error', 'Error occurred during validating data source.');
    }

    let __oSource: any = {}
    __oSource.bValidated = bValidated;
    __oSource.__oDatasource = this.__oDataSource;
    __oSource.sMessage = this.__sMessage;
    return __oSource;
  }
}
